var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowRight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.00033C2 7.63214 2.29848 7.33366 2.66667 7.33366L11.7239 7.33366L8.86193 4.47173C8.60158 4.21138 8.60158 3.78927 8.86193 3.52892C9.12228 3.26857 9.54439 3.26857 9.80474 3.52892L13.8047 7.52892C14.0651 7.78927 14.0651 8.21138 13.8047 8.47173L9.80474 12.4717C9.54439 12.7321 9.12228 12.7321 8.86193 12.4717C8.60158 12.2114 8.60158 11.7893 8.86193 11.5289L11.7239 8.66699L2.66667 8.66699C2.29848 8.66699 2 8.36852 2 8.00033Z",
    fill: "#1F292E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_arrow_right.4cbefa5df2e32d42cdaf0ac38ba9b272.svg";